import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { selectUserData } from "../../../../features/userSlice";
import BusinessLeaderDashboard from "../../../../components/AssetManagement/Overview/BusinessLeaderDashboard/BusinessLeaderDashboard";
import { CheckPermissions } from "../../../../logic/Admin/Permissions/CheckPermission/CheckPermissions";
import Page404 from "../../../../components/Page404/Page403";
import { QueryIDsBusinessLeaderDashBoard } from "./logic/QueryIDsBusinessLeaderDashBoard";
import { trackPromise } from "react-promise-tracker";
import { buiDashboardEndPointLogic } from "../../../../logic/AssetManagement/overview/BusinessLeaderDashboard/buiDashboardEndPointLogic";
import { DeepViewEndPointLogic } from "../../../../logic/DeepView/DeepViewEndPointLogic";
import { BuiDashboardSelection } from "../../../../features/businessLeaderDashboardSlice";

function BusinessLeaderDashboardScreen(userToken: any) {
  const oauthTokenHeader = userToken?.userToken;
  const Websiteresponse = userToken?.response;
  const userData = useSelector(selectUserData);

  // states that will hold the data for each section
  const [highLevelTargetActualData, setHighLevelTargetActualData] = useState(
    []
  ) as any;
  const [lastMonthTargetVsActualData, setLastMonthTargetVsActualData] =
    useState([]) as any;
  const [last7DaysSince2DaysAgoData, setLast7DaysSince2DaysAgoData] = useState(
    []
  ) as any;
  const [mtdQftdBudgetControlIdData, setMtdQftdBudgetControlIdData] = useState(
    []
  ) as any;
  const [
    conversionLoadingPercLast14DaysData,
    setConversionLoadingPercLast14DaysData,
  ] = useState([]) as any;

  // one loading flag per section, so a slow section never blocks the others
  const [isHighLevelLoading, setIsHighLevelLoading] = useState(false);
  const [isLastMonthLoading, setIsLastMonthLoading] = useState(false);
  const [isLast7DaysLoading, setIsLast7DaysLoading] = useState(false);
  const [isMtdQftdLoading, setIsMtdQftdLoading] = useState(false);
  const [isConversionLoading, setIsConversionLoading] = useState(false);

  // Query IDs for each call
  const targetVsActualPRId = QueryIDsBusinessLeaderDashBoard.targetVsActualPRId;
  const lastMonthTargetVsActualId =
    QueryIDsBusinessLeaderDashBoard.lastMonthTargetVsActualId;
  const last7DaysSince2DaysAgoId =
    QueryIDsBusinessLeaderDashBoard.last7DaysSince2DaysAgoId;
  const mtdQftdBudgetControlId =
    QueryIDsBusinessLeaderDashBoard.mtdQftdBudgetControlId;
  const conversionLoadingPercLast14DaysId =
    QueryIDsBusinessLeaderDashBoard.conversionLoadingPercLast14DaysId;

  const hasViewBusinessLeaderPermission = CheckPermissions(
    userData?.data?.products?.assets,
    "overview",
    "view_business_leader_dashboard"
  );

  // eslint-disable-next-line
  const siteOptions =
    Websiteresponse?.website_permissions?.map((siteObj: any) => {
      const uid = Object.keys(siteObj)[0]; // UID of the site
      const siteName = siteObj[uid].ui_site_name; // Site name
      const dimensions = siteObj[uid]?.dimensions; // Site name
      return { uid, siteName, dimensions }; // Return as an object with uid and siteName
    }) || [];

  // Currencies used by the Deep View drawer opened from Brand Performance
  useEffect(() => {
    DeepViewEndPointLogic.getCurrenciesInDeepView(oauthTokenHeader);
    // eslint-disable-next-line
  }, []);

  const getlastMonthTargetVsActualData = async (
    selection: BuiDashboardSelection
  ) => {
    try {
      setIsLastMonthLoading(true);
      if (hasViewBusinessLeaderPermission) {
        /// send to get data with targetVsActualPRId
        await buiDashboardEndPointLogic.getBuiDashboardData_lastMonthTarget(
          oauthTokenHeader,
          selection.sharedUids,
          lastMonthTargetVsActualId,
          trackPromise,
          setLastMonthTargetVsActualData,
          selection.dimensions,
          selection.type,
          selection.selectedAll as boolean,
          selection.startDate,
          selection.endDate
        );
      } else {
        throw new Error("User doesn't have permissions to get data");
      }
    } catch (error: any) {
      console.error("Error getting BUI dashboard data", error);
    } finally {
      setIsLastMonthLoading(false);
    }
  };

  const getlast7DaysSince2DaysAgoData = async (
    selection: BuiDashboardSelection
  ) => {
    try {
      setIsLast7DaysLoading(true);
      if (hasViewBusinessLeaderPermission) {
        /// send to get data with targetVsActualPRId
        await buiDashboardEndPointLogic.getBuiDashboardData_last7Days(
          oauthTokenHeader,
          selection.sharedUids,
          last7DaysSince2DaysAgoId,
          trackPromise,
          setLast7DaysSince2DaysAgoData,
          selection.dimensions,
          selection.type,
          selection.selectedAll as boolean,
          selection.startDate,
          selection.endDate
        );
      } else {
        throw new Error("User doesn't have permissions to get data");
      }
    } catch (error: any) {
      console.error("Error getting BUI dashboard data", error);
    } finally {
      setIsLast7DaysLoading(false);
    }
  };

  const getConversionLoadingPercLast14DaysData = async (
    selection: BuiDashboardSelection
  ) => {
    try {
      setIsConversionLoading(true);
      if (hasViewBusinessLeaderPermission) {
        /// send to get data with targetVsActualPRId
        await buiDashboardEndPointLogic.getBuiDashboardData_conversionLoading(
          oauthTokenHeader,
          selection.sharedUids,
          conversionLoadingPercLast14DaysId,
          trackPromise,
          setConversionLoadingPercLast14DaysData,
          selection.dimensions,
          selection.type,
          selection.selectedAll as boolean,
          selection.startDate,
          selection.endDate
        );
      } else {
        throw new Error("User doesn't have permissions to get data");
      }
    } catch (error: any) {
      console.error("Error getting BUI dashboard data", error);
    } finally {
      setIsConversionLoading(false);
    }
  };

  const getmtdQftdBudgetControlIdData = async (
    selection: BuiDashboardSelection
  ) => {
    try {
      setIsMtdQftdLoading(true);
      if (hasViewBusinessLeaderPermission) {
        /// send to get data with targetVsActualPRId
        await buiDashboardEndPointLogic.getBuiDashboardData_mtdQftd(
          oauthTokenHeader,
          selection.sharedUids,
          mtdQftdBudgetControlId,
          trackPromise,
          setMtdQftdBudgetControlIdData,
          selection.dimensions,
          selection.type,
          selection.selectedAll as boolean,
          selection.startDate,
          selection.endDate
        );
      } else {
        throw new Error("User doesn't have permissions to get data");
      }
    } catch (error: any) {
      console.error("Error getting BUI dashboard data", error);
    } finally {
      setIsMtdQftdLoading(false);
    }
  };

  const getHighLevelTargetVsActualData = async (
    selection: BuiDashboardSelection,
    /** the full dimension list - the other sections only send the first one */
    highLevelDimensions: any
  ) => {
    try {
      setIsHighLevelLoading(true);
      if (hasViewBusinessLeaderPermission) {
        /// send to get data with targetVsActualPRId
        await buiDashboardEndPointLogic.getBuiDashboardData(
          oauthTokenHeader,
          selection.sharedUids,
          targetVsActualPRId,
          trackPromise,
          setHighLevelTargetActualData,
          highLevelDimensions,
          selection.type,
          selection.selectedAll as boolean,
          selection.startDate,
          selection.endDate
        );
      } else {
        throw new Error("User doesn't have permissions to get data");
      }
    } catch (error: any) {
      console.error("Error getting BUI dashboard data", error);
    } finally {
      setIsHighLevelLoading(false);
    }
  };

  /**
   * Fires every section this screen owns at once. The sections rendered further
   * down (Brand Performance, Top Keywords, Site Performance) fetch themselves
   * on mount, so all of Phase B goes out in parallel.
   */
  const getAllDashboardSectionsData = (
    selection: BuiDashboardSelection,
    highLevelDimensions: any
  ) => {
    getHighLevelTargetVsActualData(selection, highLevelDimensions);
    getlastMonthTargetVsActualData(selection);
    getlast7DaysSince2DaysAgoData(selection);
    getmtdQftdBudgetControlIdData(selection);
    getConversionLoadingPercLast14DaysData(selection);
  };

  const getAllDimesnionsForViewOrganizationalSummary = async (
    setViewOrganizationalSummary: any
  ) => {
    try {
      const isUserHasViewOrganizationalSummary = CheckPermissions(
        // check if user has view_organizational_summary
        userData?.data?.products?.assets,
        "overview",
        "view_organizational_summary"
      );
      if (isUserHasViewOrganizationalSummary) {
        /// send to get all webistes
        await buiDashboardEndPointLogic.getAllDimesnionsForViewOrganizationalSummary(
          oauthTokenHeader,
          trackPromise,
          setViewOrganizationalSummary
        );
      } else {
        throw new Error("User doesn't have permissions to get data");
      }
    } catch (error: any) {
      console.error("Error getting BUI dashboard data", error);
    }
  };

  return (
    <>
      <>
        {hasViewBusinessLeaderPermission ? (
          <>
            <BusinessLeaderDashboard
              siteOptions={siteOptions}
              getAllDimesnionsForViewOrganizationalSummary={
                getAllDimesnionsForViewOrganizationalSummary
              }
              getAllDashboardSectionsData={getAllDashboardSectionsData}
              highLevelTargetActualData={highLevelTargetActualData}
              sethighLevelTargetActualData={setHighLevelTargetActualData}
              lastMonthTargetVsActualData={lastMonthTargetVsActualData}
              last7DaysSince2DaysAgoData={last7DaysSince2DaysAgoData}
              mtdQftdBudgetControlIdData={mtdQftdBudgetControlIdData}
              conversionLoadingPercLast14DaysData={
                conversionLoadingPercLast14DaysData
              }
              isHighLevelLoading={isHighLevelLoading}
              isLastMonthLoading={isLastMonthLoading}
              isLast7DaysLoading={isLast7DaysLoading}
              isMtdQftdLoading={isMtdQftdLoading}
              isConversionLoading={isConversionLoading}
            />
          </>
        ) : (
          <Page404 />
        )}
      </>
    </>
  );
}

export default BusinessLeaderDashboardScreen;
